export const getStyled = (theme) => ({
  tabContainer: {
    padding: theme.spacing(2),
  },
  popoverPaper: {
    width: '100%',
    maxWidth: 350,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1),

    '@media (maxWidth: 600px)': {
      maxWidth: 270,
    },
  },
  noShadow: {
    boxShadow: 'none !important',
  },
  icons: {
    color: '#fff',
  },
  customBadge: {
    backgroundColor: '#f44336',
    color: '#fff',
  },
});
